/*
 * After a lawn photo is taken or picked, ask which yard it shows (owner, 2026-10-30): Front yard, Back yard, Side yard or
 * Skip. The answer rides on the upload (visit_photos.room) and shows under the photo on the pay page. Closing the sheet
 * is the same as Skip, so a photo is never lost. Other trades upload at once with no question.
 */
import { useState } from "react";
import { YARD_SPOTS, YARD_WORDS, type YardSpot } from "@steward/shared";
import { useSession } from "../app/session";
import { Button } from "./parts";
import { Modal } from "./overlays";

const ASK = {
  en: { one: "Where is this photo?", many: "Where are these photos?", skip: "Skip" },
  es: { one: "¿Dónde es esta foto?", many: "¿Dónde son estas fotos?", skip: "Saltar" },
};

export function useYardAsk() {
  const { me, company } = useSession();
  const lang = me.locale === "es" ? "es" : "en";
  const [waiting, setWaiting] = useState<{ many: boolean; go: (room: YardSpot | null) => void } | null>(null);
  /** Runs go with the yard picked (null for Skip), straight away when the company is not lawn. */
  const ask = (count: number, go: (room: YardSpot | null) => void) => {
    if (company.trade === "lawn") setWaiting({ many: count > 1, go });
    else go(null);
  };
  const answer = (room: YardSpot | null) => {
    const w = waiting;
    setWaiting(null);
    w?.go(room);
  };
  const sheet = (
    <Modal title={waiting?.many ? ASK[lang].many : ASK[lang].one} open={!!waiting} onClose={() => answer(null)}>
      <div className="yard-ask">
        {YARD_SPOTS.map((s) => (
          <Button key={s} type="secondary" onClick={() => answer(s)}>
            {YARD_WORDS[lang][s]}
          </Button>
        ))}
        <Button type="tertiary" onClick={() => answer(null)}>
          {ASK[lang].skip}
        </Button>
      </div>
    </Modal>
  );
  return { ask, sheet };
}
